module.exports = __webpack_public_path__ + "media/estates/marker-879ea6ea.svg";